/** Tipos de la API /platform (espejo de apps/cloud-api/src/platform/router.py). */

export type TenantStatus = "active" | "trial" | "suspended" | "cancelled";

export interface LoginOut {
  access_token: string;
  requires_2fa_setup: boolean;
}

export interface OperatorOut {
  id: string;
  email: string;
  full_name: string;
  has_2fa: boolean;
}

export interface TotpSetupOut {
  secret: string;
  otpauth_uri: string;
  qr_image: string;
}

export interface TenantOut {
  id: string;
  ruc: string;
  legal_name: string;
  trade_name: string | null;
  plan: string;
  status: TenantStatus;
  created_at: string;
  branches: number;
  active_users: number;
  sales_today: number;
  sales_today_total: string;
  last_sale_at: string | null;
  billing_pending: number;
  billing_rejected: number;
  nodes: number;
  nodes_down: number;
  nodes_backup_stale: number;
}

export interface MetricsOut {
  tenants_by_status: Record<string, number>;
  sales_today: number;
  sales_today_total: string;
  nodes: number;
  nodes_down: number;
  nodes_backup_stale: number;
  billing_pending: number;
  billing_rejected: number;
}

export interface NodeOut {
  id: string;
  tenant_id: string;
  branch_id: string | null;
  name: string;
  is_active: boolean;
  last_seen_at: string | null;
  secret_version: number;
}

export interface TenantCreatedOut {
  tenant: TenantOut;
  first_branch: {
    branch_id: string;
    code: string;
    boleta_series: string;
    factura_series: string;
    terminals: number;
  } | null;
  /** Credenciales del server local (una sola vez), si se pidió. */
  node_env: Record<string, string> | null;
}

export interface NodeCredentialsOut {
  node: NodeOut;
  env: Record<string, string>;
}

export const STATUS_LABELS: Record<TenantStatus, string> = {
  active: "Activa",
  trial: "Prueba",
  suspended: "Suspendida",
  cancelled: "Cancelada",
};

export const STATUS_TONES: Record<TenantStatus, string> = {
  active: "bg-emerald-100 text-emerald-800",
  trial: "bg-sky-100 text-sky-800",
  suspended: "bg-amber-100 text-amber-800",
  cancelled: "bg-slate-200 text-slate-600",
};

export function formatPEN(value: string | number): string {
  return `S/ ${Number(value).toLocaleString("es-PE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function ago(iso: string | null): string {
  if (!iso) return "nunca";
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60_000);
  if (minutes < 1) return "recién";
  if (minutes < 60) return `hace ${minutes} min`;
  if (minutes < 48 * 60) return `hace ${Math.round(minutes / 60)} h`;
  return new Date(iso).toLocaleDateString("es-PE");
}
